import { FormArray, ValidatorFn } from '@angular/forms';

export function atLeastOneCheckboxCheckedValidator(min = 1): ValidatorFn {
  return (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map((control) => control.value)
      .reduce((prev, next) => (next ? prev + next : prev), 0);

    return totalSelected >= min ? null : { required: true };
  };
}

// Same as
// export function atLeastOneCheckboxCheckedValidator(min = 1) {
//   const validator: ValidatorFn = (formArray: FormArray) => {
//     const totalSelected = formArray.controls
//       .map((control) => control.value)
//       .reduce((prev, next) => (next ? prev + next : prev), 0);

//     return totalSelected >= min ? null : { required: true };
//   };

//   return validator;
// }
